import { Link, useNavigate } from 'react-router-dom';
import { useSession } from '@/features/auth/session/context';
import { Icon } from '@/components/foundations';

export type UserMenuProps = {
  initials: string;
  /** Nome ao lado do avatar (topo do checkout). */
  name?: string;
  /** Avatar dourado (loja). */
  gold?: boolean;
  to?: string;
};

/** Avatar + chevron ("Sair"). Com sessão, encerra a sessão (`signOut`) e volta para o login. */
export function UserMenu({ initials, name, gold = false, to = '/auth' }: UserMenuProps) {
  const session = useSession();
  const navigate = useNavigate();
  const loggedIn = session.status === 'ready' && !!session.viewer;
  return (
    <Link
      className="user"
      to={to}
      title="Sair"
      onClick={
        loggedIn
          ? (e) => {
              e.preventDefault();
              void session.signOut().then(() => navigate(to));
            }
          : undefined
      }
    >
      <span className={`avatar${gold ? ' gold' : ''}`}>{initials}</span>
      {name && `${name} `}
      <Icon name="down" />
    </Link>
  );
}
